import {
  Home, Lightbulb, ShoppingCart, Tag, Heart, ShoppingBag, Percent, Truck,
  MousePointerClick, DollarSign, ClipboardCheck, Wrench, LineChart, Search,
  PenLine, Star, MessageSquareText, Package, Radar, FlaskConical, BarChart3,
  MessageCircle, Users, CreditCard, KeyRound, Settings, HelpCircle, Wallet, LifeBuoy, ShieldAlert,
  PackageCheck, Flame, Megaphone, Dices,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavItem {
  path: string;
  label: string;
  icon: LucideIcon;
}

export interface NavSection {
  title?: string;
  items: NavItem[];
  collapseAfter?: number;
}

export const SECTIONS: NavSection[] = [
  { items: [{ path: '/', label: 'Dashboard', icon: Home }] },
  {
    title: 'Revenue Growth',
    collapseAfter: 4,
    items: [
      { path: '/recommendations', label: 'Recommendations', icon: Lightbulb },
      { path: '/upsell', label: 'Upsell & Cross-Sell', icon: ShoppingCart },
      { path: '/price-optimization', label: 'Price Optimization', icon: Tag },
      { path: '/winback', label: 'Customer Win-Back', icon: Heart },
      { path: '/abandoned-carts', label: 'Abandoned Cart Recovery', icon: ShoppingBag },
      { path: '/bundles', label: 'Bundle Discounts', icon: Percent },
      { path: '/free-shipping-bar', label: 'Free Shipping Bar', icon: Truck },
      { path: '/exit-intent-popup', label: 'Exit-Intent Popup', icon: MousePointerClick },
      { path: '/back-in-stock', label: 'Back-in-Stock Alerts', icon: PackageCheck },
      { path: '/urgency-scarcity', label: 'Urgency & Scarcity Bar', icon: Flame },
      { path: '/social-proof', label: 'Social Proof Popups', icon: Megaphone },
      { path: '/spin-to-win', label: 'Spin-to-Win Popup', icon: Dices },
      { path: '/sales-insights', label: 'Sales & Customer Insights', icon: DollarSign },
      { path: '/profit-insights', label: 'Profit & Margin Insights', icon: Wallet },
      { path: '/support-faq', label: 'Support FAQ Widget', icon: LifeBuoy },
    ],
  },
  {
    title: 'Store Optimization',
    collapseAfter: 4,
    items: [
      { path: '/audits', label: 'Store Audits', icon: ClipboardCheck },
      { path: '/auto-fix', label: 'Auto Fix', icon: Wrench },
      { path: '/marketing-audit', label: 'Marketing Audit', icon: LineChart },
      { path: '/keywords', label: 'SEO Keywords', icon: Search },
      { path: '/copywriter', label: 'AI Copywriter', icon: PenLine },
      { path: '/reviews', label: 'Product Reviews', icon: Star },
      { path: '/review-requests', label: 'Review Requests', icon: MessageSquareText },
    ],
  },
  {
    title: 'Operations',
    items: [
      { path: '/inventory-forecast', label: 'Inventory Forecasting', icon: Package },
      { path: '/competitors', label: 'Competitor Analysis', icon: Radar },
      { path: '/ab-tests', label: 'A/B Tests', icon: FlaskConical },
      { path: '/fraud-protection', label: 'Fraud & Bot-Order Protection', icon: ShieldAlert },
    ],
  },
  {
    title: 'Analytics',
    items: [
      { path: '/reports', label: 'Reports', icon: BarChart3 },
      { path: '/chat', label: 'AI Chat', icon: MessageCircle },
    ],
  },
  {
    title: 'Account',
    collapseAfter: 3,
    items: [
      { path: '/team', label: 'Team', icon: Users },
      { path: '/billing', label: 'Billing', icon: CreditCard },
      { path: '/api-keys', label: 'API Keys', icon: KeyRound },
      { path: '/settings', label: 'Settings', icon: Settings },
      { path: '/help', label: 'Help', icon: HelpCircle },
    ],
  },
];
